module.exports = __webpack_public_path__ + "img/logo-white.a88553c4.svg";